import { render, staticRenderFns } from "./MainTable.vue?vue&type=template&id=5fdad28a&scoped=true&"
import script from "./MainTable.vue?vue&type=script&lang=js&"
export * from "./MainTable.vue?vue&type=script&lang=js&"
import style0 from "./MainTable.vue?vue&type=style&index=0&id=5fdad28a&lang=sass&scoped=true&"
import style1 from "./MainTable.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fdad28a",
  null
  
)

export default component.exports